import { Alert } from '@design-system/components/alert/alert';

export const SubscriptionPriceAlert = ({
  show,
  subscriptionSettingsPath,
}: {
  show: boolean;
  subscriptionSettingsPath: string;
}) => {
  if (!show) return null;

  return (
    <Alert
      variant="error"
      title="Subscription price is required"
      details="Set subscription price to publish your programs"
      action={{
        label: 'Set price',
        to: subscriptionSettingsPath,
      }}
      wrapperClassName="w-[480px]"
    />
  );
};
